import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/meli.svg";

const MeliIcon = () => {
  return <YourSvg />;
};

export default MeliIcon;
